import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../../../core/services/session-storage/session-storage.service';
import { environment } from '../../../../environments/environment';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { InitiateModel } from '../ad-interface/initiate.model';
import { DeclarationSectionPayload } from '../ad-interface/adviser-response.model';
import { PersonalsectionpostModel } from '../ad-interface/personalsectionpost.model';
import { SpousesectionpostModel } from '../ad-interface/spousesectionpost.model';
import { MiscellanioussectionpostModel } from '../ad-interface/miscellanioussectionpost.model';
import { GetdetailsModel } from '../ad-interface/getdetails.model';
@Injectable({
  providedIn: 'root'
})
export class AdService {
  private sessionStorageService = inject(SessionStorageService)
  async getdeclaration() {

    const API_URL: string = environment.baseUrl + environment.apis.getdeclaration
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'GET',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      // data: {
      //   "piasRepCode": this.sessionStorageService.getCurrentRepCode().toString()
      // }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        // We just pass the raw array straight through!
        return JSON.stringify(httpResponse);
      })
      //  We catch any errors safely
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async initiatedeclaration(payload: InitiateModel) {

    const API_URL: string =
      environment.baseUrl + environment.apis.updatedeclaration;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization':
          this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: payload
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async savedeclarationquestion(payload: DeclarationSectionPayload): Promise<any> {

    const API_URL: string =
      environment.baseUrl + environment.apis.savedeclarationquestion;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: JSON.stringify(payload) // Axios sends the array directly
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        // We just pass the raw array straight through!
        return JSON.stringify(httpResponse);
      })
      //  We catch any errors safely
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async getdashboard() {

    const API_URL: string = environment.baseUrl + environment.apis.getdashboard;
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'GET',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      // data: {
      //   "piasRepCode": this.sessionStorageService.getCurrentRepCode().toString()
      // }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      //  We catch any errors safely
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }
  async getDropdownOptions() {

    const API_URL: string = environment.baseUrl + environment.apis.getDropdownOptions;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'GET',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async savepersonaldetails(
    payload: PersonalsectionpostModel
  ): Promise<any> {

    const API_URL =
      environment.baseUrl + environment.apis.savepersonaldetails;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: JSON.stringify(payload)
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async savespousedetails(payload: SpousesectionpostModel): Promise<any> {

    const API_URL: string =
      environment.baseUrl + environment.apis.savespousedetails;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: JSON.stringify(payload) // Axios sends the array directly
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async savemicellaneous(payload: MiscellanioussectionpostModel): Promise<any> {

    const API_URL: string =
      environment.baseUrl + environment.apis.savemiscellaneous;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: JSON.stringify(payload) // Axios sends the array directly
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async getdeclarationapproval(): Promise<any> {

    const API_URL: string = environment.baseUrl + environment.apis.sentdeclarationforapproval
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'GET',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      // data: {
      //   "piasRepCode": this.sessionStorageService.getCurrentRepCode().toString()
      // }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async getdeclarationstatus() {

    const API_URL: string = environment.baseUrl + environment.apis.getstatus
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'GET',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      // data: {
      //   "piasRepCode": this.sessionStorageService.getCurrentRepCode().toString()
      // }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }
  async getDeclarationDetails(payload: GetdetailsModel): Promise<any> {

    const API_URL: string =
      environment.baseUrl + environment.apis.getdeclarationdata;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization':
          this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: JSON.stringify(payload)
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }
  async uploadfile(file: File): Promise<any> {

    const API_URL =
      environment.baseUrl +
      environment.apis.uploaddocument;

    const formData = new FormData();

    formData.append('form-id', file);

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      url: API_URL,
      headers: {
        Authorization:
          this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: formData
    };

    return axios.request(REQUEST_CONFIG)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }
  async removefile(documentPath: string): Promise<any> {

    const API_URL =
      environment.baseUrl +
      environment.apis.uploaddocument;

    const payload = {
      AnnualDeclarationDocument: documentPath
    };

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      url: API_URL,
      headers: {
        Authorization:
          this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: payload
    };

    return axios.request(REQUEST_CONFIG)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }


}
